import React from 'react';

import * as S from './BusinessProfile.styles';

const BusinessProfile = ({updateDetailsExceptName, errors, countryCodes}) => (
  <S.PersonalProfileWrapDiv>
    <S.GuestTxtWrapDiv>
      <S.PricingTxtSpan>BUSINESS PROFILE</S.PricingTxtSpan>
    </S.GuestTxtWrapDiv>

    <S.ProfileDetailsEntryWrapDiv>
      <S.NameDetailsEntryWrapDiv>
        <S.TitleTxtWrapSpan>GST Number</S.TitleTxtWrapSpan>
        <S.NameEnterInput
          type="text"
          placeholder="EG: 22AAAAAA000A1Z5"
          onBlur={e => updateDetailsExceptName('gstNumber', e.target.value)}
          errorBorder={(errors.gstNumber?.message && true) || false}
        />
        <S.ErrorMessageDiv>{errors.gstNumber?.message}</S.ErrorMessageDiv>
      </S.NameDetailsEntryWrapDiv>
      <S.NameDetailsEntryWrapDiv>
        <S.TitleTxtWrapSpan>Company Name</S.TitleTxtWrapSpan>
        <S.NameEnterInput
          type="text"
          placeholder="Enter Company Name"
          onBlur={e => updateDetailsExceptName('companyName', e.target.value)}
          errorBorder={(errors.companyName?.message && true) || false}
        />
        <S.ErrorMessageDiv>{errors.companyName?.message}</S.ErrorMessageDiv>
      </S.NameDetailsEntryWrapDiv>
    </S.ProfileDetailsEntryWrapDiv>

    <S.ProfileDetailsEntryWrapDiv>
      <S.NameDetailsEntryWrapDiv>
        <S.TitleTxtWrapSpan>Business Email ID</S.TitleTxtWrapSpan>
        <S.MobileEnterInput
          type="text"
          placeholder="Enter Email Address"
          onBlur={e => updateDetailsExceptName('businessEmail', e.target.value)}
          errorBorder={(errors.businessEmail?.message && true) || false}
        />
        <S.ErrorMessageDiv>{errors.businessEmail?.message}</S.ErrorMessageDiv>
      </S.NameDetailsEntryWrapDiv>
    </S.ProfileDetailsEntryWrapDiv>

    <S.ProfileDetailsEntryWrapDiv>
      <S.NameDetailsEntryWrapDiv>
        <S.TitleTxtWrapSpan>Company Address</S.TitleTxtWrapSpan>
        <S.AddressNewEnterInput
          type="text"
          placeholder="Enter Company Address"
          onBlur={e => updateDetailsExceptName('companyAddress', e.target.value)}
          errorBorder={(errors.companyAddress?.message && true) || false}
        />
        <S.ErrorMessageDiv>{errors.companyAddress?.message}</S.ErrorMessageDiv>
      </S.NameDetailsEntryWrapDiv>
    </S.ProfileDetailsEntryWrapDiv>

    <S.ProfileDetailsEntryWrapDiv>
      <S.NameDetailsEntryWrapDiv>
        <S.TitleTxtWrapSpan>Company Phone Number</S.TitleTxtWrapSpan>

        <S.MobileInputOuterWrap>
          <S.NameEnterInput
            type="text"
            placeholder="Enter Phone Number"
            onBlur={e => updateDetailsExceptName('companyPhone', e.target.value)}
            errorBorder={(errors.companyPhone?.message && true) || false}
          />
        </S.MobileInputOuterWrap>

        <S.ErrorMessageDiv>{errors.companyPhone?.message}</S.ErrorMessageDiv>
      </S.NameDetailsEntryWrapDiv>
      <S.NameDetailsEntryWrapDiv>
        <S.TitleTxtWrapSpan>Admin Email ID</S.TitleTxtWrapSpan>
        <S.NameEnterInput
          type="text"
          placeholder="Enter Email Address"
          onBlur={e => updateDetailsExceptName('companyEmail', e.target.value)}
          errorBorder={(errors.companyEmail?.message && true) || false}
        />
        <S.ErrorMessageDiv>{errors.companyEmail?.message}</S.ErrorMessageDiv>
      </S.NameDetailsEntryWrapDiv>
    </S.ProfileDetailsEntryWrapDiv>
  </S.PersonalProfileWrapDiv>
);

export default BusinessProfile;
